module.exports = __webpack_public_path__ + "media/src/images/icons/flags/united_states-342f595575a113635127fdb31e8aa748.svg";